
['turbo:load','turbo:frame-load'].forEach(function(e) {
  document.addEventListener(e, function(event) {
    $("#mySearchFilterInput").on("keyup", function() {
      var value = normalizeString($(this).val().toLowerCase());
      $("#mySearchFilterInputContent tr").filter(function() {
        $(this).toggle(normalizeString($(this).text().toLowerCase()).indexOf(value) > -1);
      });
    });
  
    // Function to normalize strings and remove accents
    function normalizeString(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
  });
});
